import { render } from "./Earnings.vue?vue&type=template&id=4c8c6c67&ts=true"
import script from "./Earnings.vue?vue&type=script&lang=ts"
export * from "./Earnings.vue?vue&type=script&lang=ts"

import exportComponent from "/home/starkoms/webapps/front-comm-starkoms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__